import classnames from 'classnames';
import { useArrowKeyNavigation } from '../../hooks/use-arrow-key-navigation';
import { useSyncedRef } from '../../hooks/use-synced-ref';
import { downcastRef } from '../../util/typing';
import { jsx as _jsx } from "preact/jsx-runtime";
/**
 * Render a tablist container for a set of tabs, with arrow key navigation per
 * https://www.w3.org/WAI/ARIA/apg/patterns/tabpanel/
 */
export default function TabList({
  children,
  classes,
  elementRef,
  vertical = false,
  ...htmlAttributes
}) {
  const tabListRef = useSyncedRef(elementRef);
  useArrowKeyNavigation(tabListRef, {
    selector: 'button',
    horizontal: true,
    vertical
  });
  return _jsx("div", {
    "data-component": "TabList",
    ...htmlAttributes,
    ref: downcastRef(tabListRef),
    className: classnames('flex focus-visible-ring', {
      'flex-col': vertical
    }, classes),
    role: "tablist",
    "aria-orientation": vertical ? 'vertical' : 'horizontal',
    children: children
  });
}
//# sourceMappingURL=TabList.js.map